import React, { useContext, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Avatar from "@mui/material/Avatar";
import { Link, NavLink } from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Logout from "@mui/icons-material/Logout";
// import "./navbar.css";
import "./DynamicFormNavbar.css";
import DataContext from "../../../context/DataContext";
import KeyIcon from "@mui/icons-material/Key";
import { Modal } from "@mui/material";
import Changepassword from "../../change-password/Changepassword";
import $ from "jquery";
import { IoMdExit } from "react-icons/io";
import useDidMountEffect from "../../../hooks/useDidMountEffect";
// import NotificationPanel from "../../../home-module/signup-page/Notification-panel-page/NotificationPanel";

import CustomLink from "../../common-page/CustomLink";
import AlertPanel from "../../home-module/signup-page/Alert-panel-page/AlertPanel";
import apiService from "../../../api/apiService";
// import AlertPanel from "./home-module/signup-page/Alert-panel-page/AlertPanel";
const DynamicFormNavbar = ({ scrollContact, scrollAbout }) => {
    const {
        navigator,
        modalstyle,
        handleClose,
        userLogo,
        tanseedPartnerRemoveFilter,
        tanseedJuryRemoveFilter,
        notificationBell,
    } = useContext(DataContext);
    const [anchorEl, setAnchorEl] = useState();
    const [anchorElNav, setAnchorElNav] = useState(null);
    const userName = localStorage.getItem("name");
    const openMenu = Boolean(anchorEl);

    const role = localStorage.getItem("role");
    const logoutBtn = () => {
        window.close();
    };
    $(document).ready(function () {
        $(window).on("scroll", function () {
            if ($(this).scrollTop() > 90) {
                $(".appNavbar").addClass("toptotop");
                $(".appNavbar a.scroll_down").removeClass("d-none");
                $(".appNavbar a.scroll_down").addClass("d-inline");
                $(".appNavbar a.scroll_up").removeClass("d-inline");
                $(".appNavbar a.scroll_up").addClass("d-none");
            } else {
                $(".appNavbar").removeClass("toptotop");
                $(".appNavbar a.scroll_down").removeClass("d-inline");
                $(".appNavbar a.scroll_down").addClass("d-none");
                $(".appNavbar a.scroll_up").removeClass("d-none");
                $(".appNavbar a.scroll_up").addClass("d-inline");
                // debugger
            }
        });
    });


    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <AppBar
                    className="appNavbar"
                    position="fixed"
                    sx={{
                        padding: "10px",
                        backgroundColor: "#253B80",
                        boxShadow: "none",
                    }}
                >
                    <Toolbar>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            <Link
                                to={"https://startuptn.in/"}
                                target="_blank"
                            >
                                <img
                                    src="/images/startup-white.png"
                                    alt="blue horizontal.png"
                                    className="logo_img"
                                />
                            </Link>
                        </Typography>

                        {/* {userName != null && (
                            <>
                                <div>
                                    <Box>
                                        {role === "STARTUP" && (
                                            <>
                                                <span className="username1 mr-2">{userName}</span>
                                                <span className="divider"> | </span>
                                                <span className="logout ml-2 c-pointer" style={{fontSize:'18px'}} onClick={logoutBtn}>Exit <IoMdExit style={{fontSize:'20px'}}/></span>
                                            </>
                                        )}

                                    </Box>
                                </div>
                            </>
                        )} */}
                        <div>
                            <span className="username1 mr-2">{userName}</span>
                            <span className="divider"> | </span>
                            <span className="logout ml-2 c-pointer" style={{ fontSize: '18px' }} onClick={logoutBtn}>Exit <IoMdExit style={{ fontSize: '20px' }} /></span>
                        </div>
                    </Toolbar>
                </AppBar>
            </Box>

        </>
    );
};

export default DynamicFormNavbar;
